import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import localization from "../../assets/localization/localization";
import Images from "assets/images/imageData";
import "./subSideBar.scss";

const SubSideBar = ({
  match,
  activeComponent,
  homePermission,
  setSelectedTab,
  selectedTab,
}) => {
  const [isShowNavLead, setisShowNavLead] = useState(false);
  const [listActive, setListActive] = useState({
    applicationDetails: true,
    crm: false,
    fusion: false,
    lms: false,
    partner: false,
    tprequest: false,
    documents: false,
    inputrequest: false,
    UTR: false,
    notification: false,
    paymentProcess: false,
    paymentReceipt: false,
  });
  const {
    applicationDetails,
    crm,
    fusion,
    partner,
    tprequest,
    lms,
    documents,
    inputrequest,
    UTR,
    notification,
    paymentProcess,
    paymentReceipt,
  } = listActive;
  const checkActive = (type) => {
    switch (type) {
      case 1:
        setSelectedTab(1);
        setListActive((state) => ({
          crm: true,
          applicationDetails: false,
          fusion: false,
          lms: false,
          partner: false,
          tprequest: false,
          documents: false,
          inputrequest: false,
          notification: false,
          UTR: false,
          paymentProcess: false,
          paymentReceipt: false
        }));
        break;
      case 2:
        setSelectedTab(2);
        setListActive((state) => ({
          crm: false,
          applicationDetails: false,
          fusion: false,
          lms: false,
          partner: false,
          tprequest: true,
          documents: false,
          inputrequest: false,
          notification: false,
          UTR: false,
          paymentProcess: false,
          paymentReceipt: false,
        }));
        break;
      case 3:
        setSelectedTab(3);
        setListActive((state) => ({
          crm: false,
          applicationDetails: false,
          fusion: true,
          lms: false,
          partner: false,
          tprequest: false,
          documents: false,
          inputrequest: false,
          notification: false,
          UTR: false,
          paymentProcess: false,
          paymentReceipt: false,
        }));
        break;
      case 4:
        setSelectedTab(4);
        setListActive((state) => ({
          crm: false,
          applicationDetails: false,
          fusion: false,
          lms: false,
          partner: true,
          tprequest: false,
          documents: false,
          inputrequest: false,
          notification: false,
          UTR: false,
          paymentProcess: false,
          paymentReceipt: false,
        }));
        break;
      case 5:
        setSelectedTab(5);
        setListActive((state) => ({
          crm: false,
          applicationDetails: false,
          fusion: false,
          lms: true,
          partner: false,
          tprequest: false,
          documents: false,
          inputrequest: false,
          notification: false,
          UTR: false,
          paymentProcess: false,
          paymentReceipt: false,
        }));
        break;
      case 6:
        setSelectedTab(6);
        setListActive((state) => ({
          crm: false,
          applicationDetails: false,
          fusion: false,
          lms: false,
          partner: false,
          tprequest: false,
          documents: true,
          inputrequest: false,
          notification: false,
          UTR: false,
          paymentProcess: false,
          paymentReceipt: false,
        }));
        break;
      case 7:
        setSelectedTab(7);
        setListActive((state) => ({
          crm: false,
          applicationDetails: false,
          fusion: false,
          lms: false,
          partner: false,
          tprequest: false,
          documents: false,
          inputrequest: true,
          notification: false,
          UTR: false,
          paymentProcess: false,
          paymentReceipt: false,
        }));
        break;
      case 8:
        setSelectedTab(8);
        setListActive((state) => ({
          crm: false,
          applicationDetails: false,
          fusion: false,
          lms: false,
          partner: false,
          tprequest: false,
          documents: false,
          inputrequest: false,
          notification: false,
          UTR: true,
          paymentProcess: false,
          paymentReceipt: false,
        }));
        break;
      case 9:
        setSelectedTab(9);
        setListActive((state) => ({
          crm: false,
          applicationDetails: false,
          fusion: false,
          lms: false,
          partner: false,
          tprequest: false,
          documents: false,
          inputrequest: false,
          UTR: false,
          notification: true,
          paymentProcess: false,
          paymentReceipt: false,
        }));
        break;
      case 10:
        setSelectedTab(10);
        setListActive((state) => ({
          crm: false,
          applicationDetails: false,
          fusion: false,
          lms: false,
          partner: false,
          tprequest: false,
          documents: false,
          inputrequest: false,
          UTR: false,
          notification: false,
          paymentProcess: true,
          paymentReceipt: false,
        }));
        break;
        case 11:
          setSelectedTab(11);
          setListActive((state) => ({
            crm: false,
            applicationDetails: false,
            fusion: false,
            lms: false,
            partner: false,
            tprequest: false,
            documents: false,
            inputrequest: false,
            UTR: false,
            notification: false,
            paymentProcess: false,
            paymentReceipt: true,
          }));
          break;
      default:
        setSelectedTab(0);
        setListActive((state) => ({
          documents: false,
          applicationDetails: true,
          crm: false,
          fusion: false,
          lms: false,
          partner: false,
          tprequest: false,
          inputrequest: false,
          UTR: false,
          notification: false,
          paymentProcess: false,
          paymentReceipt: false,
        }));
    }
  };
  return (
    <aside className="main-sub-sidebar scrollbar-styling sub-side">
      <section className="sidebar">
        <ul className="sidebar-menu tree">
          <li className={applicationDetails ? "active" : ""}>
            <Link to={`#`} onClick={() => checkActive(0)}>
              {localization.applicationDetail}
            </Link>
          </li>
          <li className={crm ? "active" : ""}>
            <Link to={`#`} onClick={() => checkActive(1)}>
              {localization.crm}
            </Link>
          </li>
          <li className={fusion ? "active" : ""}>
            <Link
              to={`#`}
              onClick={() => {
                checkActive(3);
              }}
            >
              {localization.fusion}
            </Link>
          </li>
          <li className={lms ? "active" : ""}>
            <Link
              to={`#`}
              onClick={() => {
                checkActive(5);
              }}
            >
              {localization.pennant}
            </Link>
          </li>
          <li className={documents ? "active" : ""}>
            <Link
              to={`#`}
              onClick={() => {
                checkActive(6);
              }}
            >
              {localization.documents}
            </Link>
          </li>
          <li className={partner ? "active" : ""}>
            <Link
              to={`#`}
              onClick={() => {
                checkActive(4);
              }}
            >
              {localization.partnerSystem}
            </Link>
          </li>
          <li className={tprequest ? "active" : ""}>
            <Link
              to={`#`}
              onClick={() => {
                checkActive(2);
              }}
            >
              {localization.tpRequestResponse}
            </Link>
          </li>
          <li className={inputrequest ? "active" : ""}>
            <Link
              to={`#`}
              onClick={() => {
                checkActive(7);
              }}
            >
              {localization.inputRequest}
            </Link>
          </li>
          <li className={UTR ? "active" : ""}>
            <Link
              to={`#`}
              onClick={() => {
                checkActive(8);
              }}
            >
              {localization.utr}
            </Link>
          </li>
          <li className={notification ? "active" : ""}>
            <Link
              to={`#`}
              onClick={() => {
                checkActive(9);
              }}
            >
              {localization.notification}
            </Link>
          </li>
          <li className={paymentProcess ? "active" : ""}>
            <Link
              to={`#`}
              onClick={() => {
                checkActive(10);
              }}
            >
              {localization.paymentProcess}
            </Link>
          </li>
          <li className={paymentReceipt ? "active" : ""}>
            <Link
              to={`#`}
              onClick={() => {
                checkActive(11);
              }}
            >
              {localization.paymentReceipt}
            </Link>
          </li>
        </ul>
      </section>
    </aside>
  );
};

export default SubSideBar;
